import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { CapTableFieldsFragmentDoc } from '../../graphql/gql-fragments/cap-table.graphql';
import { IdentityFieldsFragmentDoc } from '../../graphql/gql-fragments/identity.graphql';
import { CapTableStakeFieldsFragmentDoc } from '../../graphql/gql-fragments/cap-table-stake.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCapTableQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlCapTableQuery = { capTable: { id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean, stakeholders: Array<{ id: string, stake: string, value?: string | null, acqCost: string, profit?: string | null, share: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, stakes: Array<{ id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null }> }> } };

export type GqlCapTablesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlCapTablesQuery = { nextShareCapitalChanges: { inSync: boolean }, capTables: Array<{ id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean }>, warrantPrograms: { totalCount: number }, company: { id: string, capTableTrialExpires?: string | null, isDemo: boolean }, companySubscription?: { canUseProFeatures: boolean } | null };

export type GqlCreateCapTableMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCreateCapTableInput;
}>;


export type GqlCreateCapTableMutation = { createCapTable: { id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean } };

export type GqlDuplicateCapTableMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.Scalars['ID']['input'];
}>;


export type GqlDuplicateCapTableMutation = { duplicateCapTable: { id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean } };

export type GqlRefreshCapTableMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlRefreshCapTableInput;
}>;


export type GqlRefreshCapTableMutation = { refreshCapTable: { id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean } };

export type GqlUpdateCapTableMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlUpdateCapTableInput;
}>;


export type GqlUpdateCapTableMutation = { updateCapTable: { id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean } };

export type GqlDeleteCapTableMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteCapTableMutation = { deleteCapTable?: void | null };

export type GqlCapTableStakesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  capTableId: Types.Scalars['ID']['input'];
}>;


export type GqlCapTableStakesQuery = { capTableStakes: Array<{ id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }> };

export type GqlCapTableStakeQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlCapTableStakeQuery = { capTableStake: { id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } } };

export type GqlCreateCapTableStakeMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCreateCapTableStakeInput;
}>;


export type GqlCreateCapTableStakeMutation = { createCapTableStake: { id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null } };

export type GqlCreateCapTableStakesMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCreateCapTableStakesInput;
}>;


export type GqlCreateCapTableStakesMutation = { createCapTableStakes: Array<{ id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null }> };

export type GqlCapTableStakeUpdateMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCapTableStakeUpdateInput;
}>;


export type GqlCapTableStakeUpdateMutation = { capTableStakeUpdate: { id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null } };

export type GqlCapTableStakeDeleteMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCapTableStakeDeleteInput;
}>;


export type GqlCapTableStakeDeleteMutation = { capTableStakeDelete: { id: string } };

export type GqlCapTableStakeSetEnabledMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCapTableStakeSetEnabledInput;
}>;


export type GqlCapTableStakeSetEnabledMutation = { capTableStakeSetEnabled: { id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null } };


export const CapTableDocument = gql`
    query CapTable($companyId: ID!, $id: ID!) {
  capTable(companyId: $companyId, id: $id) {
    ...CapTableFields
    stakeholders {
      id
      identity {
        ...IdentityFields
      }
      stake
      value
      acqCost
      profit
      share
      stakes {
        ...CapTableStakeFields
      }
    }
  }
}
    ${CapTableFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}
${CapTableStakeFieldsFragmentDoc}`;

/**
 * __useCapTableQuery__
 *
 * To run a query within a React component, call `useCapTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapTableQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCapTableQuery(baseOptions: Apollo.QueryHookOptions<GqlCapTableQuery, GqlCapTableQueryVariables> & ({ variables: GqlCapTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCapTableQuery, GqlCapTableQueryVariables>(CapTableDocument, options);
      }
export function useCapTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCapTableQuery, GqlCapTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCapTableQuery, GqlCapTableQueryVariables>(CapTableDocument, options);
        }
export function useCapTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCapTableQuery, GqlCapTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCapTableQuery, GqlCapTableQueryVariables>(CapTableDocument, options);
        }
export type CapTableQueryHookResult = ReturnType<typeof useCapTableQuery>;
export type CapTableLazyQueryHookResult = ReturnType<typeof useCapTableLazyQuery>;
export type CapTableSuspenseQueryHookResult = ReturnType<typeof useCapTableSuspenseQuery>;
export type CapTableQueryResult = Apollo.QueryResult<GqlCapTableQuery, GqlCapTableQueryVariables>;
export const CapTablesDocument = gql`
    query CapTables($companyId: ID!) {
  nextShareCapitalChanges(companyId: $companyId) {
    inSync
  }
  capTables(companyId: $companyId) {
    ...CapTableFields
  }
  warrantPrograms(companyId: $companyId, kinds: Wise) {
    totalCount
  }
  company(id: $companyId) {
    id
    capTableTrialExpires
    isDemo
  }
  companySubscription(companyId: $companyId) {
    canUseProFeatures
  }
}
    ${CapTableFieldsFragmentDoc}`;

/**
 * __useCapTablesQuery__
 *
 * To run a query within a React component, call `useCapTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapTablesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCapTablesQuery(baseOptions: Apollo.QueryHookOptions<GqlCapTablesQuery, GqlCapTablesQueryVariables> & ({ variables: GqlCapTablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCapTablesQuery, GqlCapTablesQueryVariables>(CapTablesDocument, options);
      }
export function useCapTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCapTablesQuery, GqlCapTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCapTablesQuery, GqlCapTablesQueryVariables>(CapTablesDocument, options);
        }
export function useCapTablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCapTablesQuery, GqlCapTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCapTablesQuery, GqlCapTablesQueryVariables>(CapTablesDocument, options);
        }
export type CapTablesQueryHookResult = ReturnType<typeof useCapTablesQuery>;
export type CapTablesLazyQueryHookResult = ReturnType<typeof useCapTablesLazyQuery>;
export type CapTablesSuspenseQueryHookResult = ReturnType<typeof useCapTablesSuspenseQuery>;
export type CapTablesQueryResult = Apollo.QueryResult<GqlCapTablesQuery, GqlCapTablesQueryVariables>;
export const CreateCapTableDocument = gql`
    mutation CreateCapTable($companyId: ID!, $input: CreateCapTableInput!) {
  createCapTable(companyId: $companyId, input: $input) {
    ...CapTableFields
  }
}
    ${CapTableFieldsFragmentDoc}`;
export type GqlCreateCapTableMutationFn = Apollo.MutationFunction<GqlCreateCapTableMutation, GqlCreateCapTableMutationVariables>;

/**
 * __useCreateCapTableMutation__
 *
 * To run a mutation, you first call `useCreateCapTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapTableMutation, { data, loading, error }] = useCreateCapTableMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCapTableMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCapTableMutation, GqlCreateCapTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCapTableMutation, GqlCreateCapTableMutationVariables>(CreateCapTableDocument, options);
      }
export type CreateCapTableMutationHookResult = ReturnType<typeof useCreateCapTableMutation>;
export type CreateCapTableMutationResult = Apollo.MutationResult<GqlCreateCapTableMutation>;
export type CreateCapTableMutationOptions = Apollo.BaseMutationOptions<GqlCreateCapTableMutation, GqlCreateCapTableMutationVariables>;
export const DuplicateCapTableDocument = gql`
    mutation DuplicateCapTable($companyId: ID!, $input: ID!) {
  duplicateCapTable(companyId: $companyId, input: $input) {
    ...CapTableFields
  }
}
    ${CapTableFieldsFragmentDoc}`;
export type GqlDuplicateCapTableMutationFn = Apollo.MutationFunction<GqlDuplicateCapTableMutation, GqlDuplicateCapTableMutationVariables>;

/**
 * __useDuplicateCapTableMutation__
 *
 * To run a mutation, you first call `useDuplicateCapTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCapTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCapTableMutation, { data, loading, error }] = useDuplicateCapTableMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateCapTableMutation(baseOptions?: Apollo.MutationHookOptions<GqlDuplicateCapTableMutation, GqlDuplicateCapTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDuplicateCapTableMutation, GqlDuplicateCapTableMutationVariables>(DuplicateCapTableDocument, options);
      }
export type DuplicateCapTableMutationHookResult = ReturnType<typeof useDuplicateCapTableMutation>;
export type DuplicateCapTableMutationResult = Apollo.MutationResult<GqlDuplicateCapTableMutation>;
export type DuplicateCapTableMutationOptions = Apollo.BaseMutationOptions<GqlDuplicateCapTableMutation, GqlDuplicateCapTableMutationVariables>;
export const RefreshCapTableDocument = gql`
    mutation RefreshCapTable($companyId: ID!, $input: RefreshCapTableInput!) {
  refreshCapTable(companyId: $companyId, input: $input) {
    ...CapTableFields
  }
}
    ${CapTableFieldsFragmentDoc}`;
export type GqlRefreshCapTableMutationFn = Apollo.MutationFunction<GqlRefreshCapTableMutation, GqlRefreshCapTableMutationVariables>;

/**
 * __useRefreshCapTableMutation__
 *
 * To run a mutation, you first call `useRefreshCapTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCapTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCapTableMutation, { data, loading, error }] = useRefreshCapTableMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshCapTableMutation(baseOptions?: Apollo.MutationHookOptions<GqlRefreshCapTableMutation, GqlRefreshCapTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRefreshCapTableMutation, GqlRefreshCapTableMutationVariables>(RefreshCapTableDocument, options);
      }
export type RefreshCapTableMutationHookResult = ReturnType<typeof useRefreshCapTableMutation>;
export type RefreshCapTableMutationResult = Apollo.MutationResult<GqlRefreshCapTableMutation>;
export type RefreshCapTableMutationOptions = Apollo.BaseMutationOptions<GqlRefreshCapTableMutation, GqlRefreshCapTableMutationVariables>;
export const UpdateCapTableDocument = gql`
    mutation UpdateCapTable($companyId: ID!, $input: UpdateCapTableInput!) {
  updateCapTable(companyId: $companyId, input: $input) {
    ...CapTableFields
  }
}
    ${CapTableFieldsFragmentDoc}`;
export type GqlUpdateCapTableMutationFn = Apollo.MutationFunction<GqlUpdateCapTableMutation, GqlUpdateCapTableMutationVariables>;

/**
 * __useUpdateCapTableMutation__
 *
 * To run a mutation, you first call `useUpdateCapTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapTableMutation, { data, loading, error }] = useUpdateCapTableMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapTableMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCapTableMutation, GqlUpdateCapTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCapTableMutation, GqlUpdateCapTableMutationVariables>(UpdateCapTableDocument, options);
      }
export type UpdateCapTableMutationHookResult = ReturnType<typeof useUpdateCapTableMutation>;
export type UpdateCapTableMutationResult = Apollo.MutationResult<GqlUpdateCapTableMutation>;
export type UpdateCapTableMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCapTableMutation, GqlUpdateCapTableMutationVariables>;
export const DeleteCapTableDocument = gql`
    mutation DeleteCapTable($companyId: ID!, $input: ID!) {
  deleteCapTable(companyId: $companyId, input: $input)
}
    `;
export type GqlDeleteCapTableMutationFn = Apollo.MutationFunction<GqlDeleteCapTableMutation, GqlDeleteCapTableMutationVariables>;

/**
 * __useDeleteCapTableMutation__
 *
 * To run a mutation, you first call `useDeleteCapTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCapTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCapTableMutation, { data, loading, error }] = useDeleteCapTableMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCapTableMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteCapTableMutation, GqlDeleteCapTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteCapTableMutation, GqlDeleteCapTableMutationVariables>(DeleteCapTableDocument, options);
      }
export type DeleteCapTableMutationHookResult = ReturnType<typeof useDeleteCapTableMutation>;
export type DeleteCapTableMutationResult = Apollo.MutationResult<GqlDeleteCapTableMutation>;
export type DeleteCapTableMutationOptions = Apollo.BaseMutationOptions<GqlDeleteCapTableMutation, GqlDeleteCapTableMutationVariables>;
export const CapTableStakesDocument = gql`
    query CapTableStakes($companyId: ID!, $capTableId: ID!) {
  capTableStakes(companyId: $companyId, capTableId: $capTableId) {
    ...CapTableStakeFields
    identity {
      ...IdentityFields
    }
  }
}
    ${CapTableStakeFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useCapTableStakesQuery__
 *
 * To run a query within a React component, call `useCapTableStakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapTableStakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapTableStakesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      capTableId: // value for 'capTableId'
 *   },
 * });
 */
export function useCapTableStakesQuery(baseOptions: Apollo.QueryHookOptions<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables> & ({ variables: GqlCapTableStakesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables>(CapTableStakesDocument, options);
      }
export function useCapTableStakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables>(CapTableStakesDocument, options);
        }
export function useCapTableStakesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables>(CapTableStakesDocument, options);
        }
export type CapTableStakesQueryHookResult = ReturnType<typeof useCapTableStakesQuery>;
export type CapTableStakesLazyQueryHookResult = ReturnType<typeof useCapTableStakesLazyQuery>;
export type CapTableStakesSuspenseQueryHookResult = ReturnType<typeof useCapTableStakesSuspenseQuery>;
export type CapTableStakesQueryResult = Apollo.QueryResult<GqlCapTableStakesQuery, GqlCapTableStakesQueryVariables>;
export const CapTableStakeDocument = gql`
    query CapTableStake($companyId: ID!, $id: ID!) {
  capTableStake(companyId: $companyId, id: $id) {
    ...CapTableStakeFields
    identity {
      ...IdentityFields
    }
  }
}
    ${CapTableStakeFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useCapTableStakeQuery__
 *
 * To run a query within a React component, call `useCapTableStakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapTableStakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapTableStakeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCapTableStakeQuery(baseOptions: Apollo.QueryHookOptions<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables> & ({ variables: GqlCapTableStakeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables>(CapTableStakeDocument, options);
      }
export function useCapTableStakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables>(CapTableStakeDocument, options);
        }
export function useCapTableStakeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables>(CapTableStakeDocument, options);
        }
export type CapTableStakeQueryHookResult = ReturnType<typeof useCapTableStakeQuery>;
export type CapTableStakeLazyQueryHookResult = ReturnType<typeof useCapTableStakeLazyQuery>;
export type CapTableStakeSuspenseQueryHookResult = ReturnType<typeof useCapTableStakeSuspenseQuery>;
export type CapTableStakeQueryResult = Apollo.QueryResult<GqlCapTableStakeQuery, GqlCapTableStakeQueryVariables>;
export const CreateCapTableStakeDocument = gql`
    mutation CreateCapTableStake($companyId: ID!, $input: CreateCapTableStakeInput!) {
  createCapTableStake(companyId: $companyId, input: $input) {
    ...CapTableStakeFields
  }
}
    ${CapTableStakeFieldsFragmentDoc}`;
export type GqlCreateCapTableStakeMutationFn = Apollo.MutationFunction<GqlCreateCapTableStakeMutation, GqlCreateCapTableStakeMutationVariables>;

/**
 * __useCreateCapTableStakeMutation__
 *
 * To run a mutation, you first call `useCreateCapTableStakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapTableStakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapTableStakeMutation, { data, loading, error }] = useCreateCapTableStakeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCapTableStakeMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCapTableStakeMutation, GqlCreateCapTableStakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCapTableStakeMutation, GqlCreateCapTableStakeMutationVariables>(CreateCapTableStakeDocument, options);
      }
export type CreateCapTableStakeMutationHookResult = ReturnType<typeof useCreateCapTableStakeMutation>;
export type CreateCapTableStakeMutationResult = Apollo.MutationResult<GqlCreateCapTableStakeMutation>;
export type CreateCapTableStakeMutationOptions = Apollo.BaseMutationOptions<GqlCreateCapTableStakeMutation, GqlCreateCapTableStakeMutationVariables>;
export const CreateCapTableStakesDocument = gql`
    mutation CreateCapTableStakes($companyId: ID!, $input: CreateCapTableStakesInput!) {
  createCapTableStakes(companyId: $companyId, input: $input) {
    ...CapTableStakeFields
  }
}
    ${CapTableStakeFieldsFragmentDoc}`;
export type GqlCreateCapTableStakesMutationFn = Apollo.MutationFunction<GqlCreateCapTableStakesMutation, GqlCreateCapTableStakesMutationVariables>;

/**
 * __useCreateCapTableStakesMutation__
 *
 * To run a mutation, you first call `useCreateCapTableStakesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapTableStakesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapTableStakesMutation, { data, loading, error }] = useCreateCapTableStakesMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCapTableStakesMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCapTableStakesMutation, GqlCreateCapTableStakesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCapTableStakesMutation, GqlCreateCapTableStakesMutationVariables>(CreateCapTableStakesDocument, options);
      }
export type CreateCapTableStakesMutationHookResult = ReturnType<typeof useCreateCapTableStakesMutation>;
export type CreateCapTableStakesMutationResult = Apollo.MutationResult<GqlCreateCapTableStakesMutation>;
export type CreateCapTableStakesMutationOptions = Apollo.BaseMutationOptions<GqlCreateCapTableStakesMutation, GqlCreateCapTableStakesMutationVariables>;
export const CapTableStakeUpdateDocument = gql`
    mutation CapTableStakeUpdate($companyId: ID!, $input: CapTableStakeUpdateInput!) {
  capTableStakeUpdate(companyId: $companyId, input: $input) {
    ...CapTableStakeFields
  }
}
    ${CapTableStakeFieldsFragmentDoc}`;
export type GqlCapTableStakeUpdateMutationFn = Apollo.MutationFunction<GqlCapTableStakeUpdateMutation, GqlCapTableStakeUpdateMutationVariables>;

/**
 * __useCapTableStakeUpdateMutation__
 *
 * To run a mutation, you first call `useCapTableStakeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapTableStakeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capTableStakeUpdateMutation, { data, loading, error }] = useCapTableStakeUpdateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapTableStakeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GqlCapTableStakeUpdateMutation, GqlCapTableStakeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCapTableStakeUpdateMutation, GqlCapTableStakeUpdateMutationVariables>(CapTableStakeUpdateDocument, options);
      }
export type CapTableStakeUpdateMutationHookResult = ReturnType<typeof useCapTableStakeUpdateMutation>;
export type CapTableStakeUpdateMutationResult = Apollo.MutationResult<GqlCapTableStakeUpdateMutation>;
export type CapTableStakeUpdateMutationOptions = Apollo.BaseMutationOptions<GqlCapTableStakeUpdateMutation, GqlCapTableStakeUpdateMutationVariables>;
export const CapTableStakeDeleteDocument = gql`
    mutation CapTableStakeDelete($companyId: ID!, $input: CapTableStakeDeleteInput!) {
  capTableStakeDelete(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export type GqlCapTableStakeDeleteMutationFn = Apollo.MutationFunction<GqlCapTableStakeDeleteMutation, GqlCapTableStakeDeleteMutationVariables>;

/**
 * __useCapTableStakeDeleteMutation__
 *
 * To run a mutation, you first call `useCapTableStakeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapTableStakeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capTableStakeDeleteMutation, { data, loading, error }] = useCapTableStakeDeleteMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapTableStakeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GqlCapTableStakeDeleteMutation, GqlCapTableStakeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCapTableStakeDeleteMutation, GqlCapTableStakeDeleteMutationVariables>(CapTableStakeDeleteDocument, options);
      }
export type CapTableStakeDeleteMutationHookResult = ReturnType<typeof useCapTableStakeDeleteMutation>;
export type CapTableStakeDeleteMutationResult = Apollo.MutationResult<GqlCapTableStakeDeleteMutation>;
export type CapTableStakeDeleteMutationOptions = Apollo.BaseMutationOptions<GqlCapTableStakeDeleteMutation, GqlCapTableStakeDeleteMutationVariables>;
export const CapTableStakeSetEnabledDocument = gql`
    mutation CapTableStakeSetEnabled($companyId: ID!, $input: CapTableStakeSetEnabledInput!) {
  capTableStakeSetEnabled(companyId: $companyId, input: $input) {
    ...CapTableStakeFields
  }
}
    ${CapTableStakeFieldsFragmentDoc}`;
export type GqlCapTableStakeSetEnabledMutationFn = Apollo.MutationFunction<GqlCapTableStakeSetEnabledMutation, GqlCapTableStakeSetEnabledMutationVariables>;

/**
 * __useCapTableStakeSetEnabledMutation__
 *
 * To run a mutation, you first call `useCapTableStakeSetEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapTableStakeSetEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capTableStakeSetEnabledMutation, { data, loading, error }] = useCapTableStakeSetEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapTableStakeSetEnabledMutation(baseOptions?: Apollo.MutationHookOptions<GqlCapTableStakeSetEnabledMutation, GqlCapTableStakeSetEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCapTableStakeSetEnabledMutation, GqlCapTableStakeSetEnabledMutationVariables>(CapTableStakeSetEnabledDocument, options);
      }
export type CapTableStakeSetEnabledMutationHookResult = ReturnType<typeof useCapTableStakeSetEnabledMutation>;
export type CapTableStakeSetEnabledMutationResult = Apollo.MutationResult<GqlCapTableStakeSetEnabledMutation>;
export type CapTableStakeSetEnabledMutationOptions = Apollo.BaseMutationOptions<GqlCapTableStakeSetEnabledMutation, GqlCapTableStakeSetEnabledMutationVariables>;